import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
} from '@mui/material';

export const InputDialog = ({
  show,
  onClose,
  title = "Enter Passport Numbers",
  label = "Passport Numbers",
  defaultValue = "",
}) => {
  const [inputValue, setInputValue] = useState(defaultValue);

  const handleSubmit = (e) => {
    e.preventDefault();
    onClose(inputValue);
  };

  return (
    <Dialog open={show} onClose={() => onClose(null)} fullWidth maxWidth="sm">
      <form onSubmit={handleSubmit}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label={label}
            multiline
            minRows={5}  // Adjust this value to change the minimum height
            maxRows={10} // Adjust this value to change the maximum height when expanded
            fullWidth
            variant="outlined"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            sx={{
              '& .MuiInputBase-root': {
                alignItems: 'flex-start' // Aligns the text to the top
              }
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => onClose(null)}>Cancel</Button>
          <Button type="submit" variant="contained" color="primary">
            OK
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};